import { mapValues, isPlainObject, isEmpty } from "lodash";
import ThemeCmsConstellation from "../../themes/ThemeCmsConstellation.esm.js";
function prefixSpacingTokens(marginsOrPaddings) {
  if (!marginsOrPaddings) {
    return void 0;
  }
  const res = mapValues(renameResponsiveTokens(marginsOrPaddings), function mapIt(value) {
    if (isPlainObject(value)) {
      return mapValues(value, mapIt);
    }
    if (Object.keys(ThemeCmsConstellation.constellation.spacing).includes(value)) {
      return `$spacing.${value}`;
    }
    return value;
  });
  return res;
}
function renameResponsiveTokens(responsiveStyles) {
  const nextStyles = {
    "@media $lg_lte": {},
    "@media $sm_lte": {}
  };
  Object.entries(responsiveStyles).forEach(([styleName, styleValueOrResponsiveStyleValues]) => {
    if (isPlainObject(styleValueOrResponsiveStyleValues)) {
      const responsiveStyleValues = styleValueOrResponsiveStyleValues;
      Object.entries(responsiveStyleValues).forEach(([mediaQuery, styleValue]) => {
        if (mediaQuery === "default") {
          nextStyles[styleName] = styleValue;
        } else {
          nextStyles[`@media $${mediaQuery}`][styleName] = styleValue;
        }
      });
    } else {
      const styleValue = styleValueOrResponsiveStyleValues;
      nextStyles[styleName] = styleValue;
    }
  });
  if (isEmpty(nextStyles["@media $lg_lte"])) {
    delete nextStyles["@media $lg_lte"];
  }
  if (isEmpty(nextStyles["@media $sm_lte"])) {
    delete nextStyles["@media $sm_lte"];
  }
  return nextStyles;
}
export {
  prefixSpacingTokens
};
